import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Select,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/Home";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import DeleteIcon from "@material-ui/icons/Delete";

const useStyles = makeStyles({
  quoteHeading: {
    display: "flex",
    justifyContent: "space-between",
    background: "#DEECFC",
    padding: "10px 20px",
    borderRadius: "10px",
    margin: "10px 0",
  },
  quoteContent: {
    padding: "10px 0px",
    borderRadius: "5px",
  },
  title: {
    paddingBottom: "0px",
  },
  requestQuoteTitle: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
  },
  formControl: {
    minWidth: 300,
  },
  selectEmpty: {},
  quoteContainer: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
  },
  requestQuote1Submit: {
    width: "160px",
    height: "45px",
    marginInlineEnd: "10px",
    background: "#BE1E2D",
    color: "#fff",
    marginTop: "20px",
    fontWeight: "600",
  },
});

const ProjectDetails = ({
  handleChangePdValue,
  hanldeIncrementDetails,
  productCount,
  handleCountDelete,
}) => {
  const classes = useStyles();

  const [moblieScreen, setMobileScreen] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const updateDimensions = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };
  useEffect(() => {
    if (width < 1024) {
      setMobileScreen(true);
    } else {
      setMobileScreen(false);
    }
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, [width, height]);
  return (
    <>
      <Box className="desktop">
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            columnGap: "10px",
            padding: "15px 0",
          }}
        >
          <Typography variant="span">
            <HomeIcon />
          </Typography>
          <Typography variant="h6">Product Details </Typography>
        </Box>
        <Box className="quoteHeading2">
          <Box className="firstHeading">
            <Typography variant="h5">Product</Typography>
          </Box>
          <Box className="firstHeading2">
            <Typography variant="h5">Product Classification</Typography>
          </Box>
          <Box className="firstHeading3">
            <Typography variant="h5">Qty</Typography>
          </Box>
          <Box className="firstHeading4">
            <Typography variant="h5">Weight</Typography>
          </Box>
          <Box className="firstHeading5">
            <Typography variant="h5">Size</Typography>
          </Box>
          <Box className="firstHeading6">
            <Typography variant="h5">MSDS</Typography>
          </Box>
          <Box className="firstHeading7">
            <Typography variant="h5">Packing</Typography>
          </Box>
          <Box className="firstHeading8">
            <Typography variant="h5">Package Type</Typography>
          </Box>
          <Box className="firstHeading9">
            <Typography variant="h5">Gross Value</Typography>
          </Box>
          <Box className="firstHeading10">
            <Typography variant="span">
              <AddIcon onClick={hanldeIncrementDetails} />
            </Typography>
          </Box>
        </Box>
        <Box className="requestQuoteInputParent">
          {productCount?.map((item, i) => (
            <>
              {i !== 0 && (
                <button
                  onClick={() => handleCountDelete(item, i)}
                  className="quote_details_btn"
                >
                  <DeleteIcon />
                </button>
              )}
              <Box className="requestQuoteInput">
                <Box className="input1" key={i}>
                  <FormControl
                    className={(classes.margin, classes.textField)}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-password">
                      Enter commodity type
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password"
                      type="text"
                      name="product"
                      required
                      onBlur={(e) => handleChangePdValue(e, i)}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                          >
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Box>
                <Box className="input2">
                  <FormControl
                    className={(classes.margin, classes.textField)}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-password">
                      Chemicals
                    </InputLabel>
                    <OutlinedInput
                      type="text"
                      name="productClassification"
                      onBlur={(e) => handleChangePdValue(e, i)}
                      required
                    />
                  </FormControl>
                </Box>
                <Box className="input3">
                  <FormControl
                    className={(classes.margin, classes.textField)}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-password">
                      Qty
                    </InputLabel>
                    <OutlinedInput
                      type="number"
                      name="Qty"
                      required
                      onBlur={(e) => handleChangePdValue(e, i)}
                    />
                  </FormControl>
                </Box>
                <Box className="input4">
                  <FormControl
                    className={(classes.margin, classes.textField)}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-password">
                      500 kgs
                    </InputLabel>
                    <OutlinedInput
                      type="text"
                      name="weight"
                      required
                      onBlur={(e) => handleChangePdValue(e, i)}
                    />
                  </FormControl>
                </Box>
                <Box className="input13">
                  <FormControl
                    className={(classes.margin, classes.textField)}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-password">
                      500
                    </InputLabel>
                    <OutlinedInput
                      type="text"
                      name="sizeInput"
                      required
                      onBlur={(e) => handleChangePdValue(e, i)}
                    />
                  </FormControl>
                </Box>
                <Box className="input8">
                  <FormControl
                    className={(classes.margin, classes.textField)}
                    variant="outlined"
                  >
                    <Select
                      native
                      onBlur={(e) => handleChangePdValue(e, i)}
                      name="sizeSelect"
                      required
                    >
                      <option aria-label="None" value="" selected disabled>
                        Please select
                      </option>
                      <option value={"INCH"}>INCH</option>
                      <option value={"CBM"}>CBM</option>
                    </Select>
                  </FormControl>
                </Box>
                <Box className="input9">
                  <FormControl
                    className={(classes.margin, classes.textField)}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-password"></InputLabel>
                    <OutlinedInput
                      type="text"
                      name="MSDS2"
                      required
                      onBlur={(e) => handleChangePdValue(e, i)}
                    />
                  </FormControl>
                </Box>
                <Box className="input10">
                  <FormControl
                    className={(classes.margin, classes.textField)}
                    variant="outlined"
                  >
                    <Select
                      native
                      onBlur={(e) => handleChangePdValue(e, i)}
                      name="Packing"
                      required
                    >
                      <option aria-label="None" value="" selected disabled>
                        Please select
                      </option>
                      <option value={"Packed"}>Packed</option>
                    </Select>
                  </FormControl>
                </Box>
                <Box className="input11">
                  <FormControl
                    className={(classes.margin, classes.textField)}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-password">
                      Pallets
                    </InputLabel>
                    <OutlinedInput
                      type="text"
                      required
                      name="packageType"
                      onBlur={(e) => handleChangePdValue(e, i)}
                    />
                  </FormControl>
                </Box>
                <Box className="input12">
                  <FormControl
                    className={(classes.margin, classes.textField)}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-password">
                      AED 100,000
                    </InputLabel>
                    <OutlinedInput
                      type="text"
                      name="grossValue"
                      required
                      onBlur={(e) => handleChangePdValue(e, i)}
                    />
                  </FormControl>
                </Box>
                <Box className="DetailscheckBox">
                  <FormControlLabel
                    control={
                      <Checkbox
                        onBlur={(e) => handleChangePdValue(e, i)}
                        name="stackable"
                        value={true}
                        color="primary"
                      />
                    }
                    label="Stackable"
                  />
                </Box>
              </Box>
            </>
          ))}
        </Box>
      </Box>
      <Box className="mobile">
        <Box className="product_details_mobile">
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              columnGap: "10px",
              padding: "15px 0",
            }}
          >
            <Typography variant="span">
              <HomeIcon />
            </Typography>
            <Typography variant="h6">Product Details </Typography>
          </Box>
          {productCount?.map((item, i) => (
            <>
              {i !== 0 && (
                <button
                  onClick={() => handleCountDelete(item, i)}
                  className="quote_details_btn"
                >
                  <DeleteIcon />
                </button>
              )}
              <Box className="quoteHeading2" key={i}>
                <Box className="firstHeading10">
                  <Typography variant="span">
                    <AddIcon onClick={hanldeIncrementDetails} />
                  </Typography>
                </Box>
                <Box className="firstHeading">
                  <Typography variant="h5">Product</Typography>
                  <Box className="input1">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        Enter commodity type
                      </InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-password"
                        type="text"
                        name="product"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </Box>
                </Box>
                <Box className="firstHeading2">
                  <Typography variant="h5">Product Classification</Typography>
                  <Box className="input2m">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        Chemicals
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        name="productClassification"
                        onBlur={(e) => handleChangePdValue(e, i)}
                        required
                      />
                    </FormControl>
                  </Box>
                </Box>
                <Box className="firstHeading3">
                  <Typography variant="h5">Qty</Typography>
                  <Box className="input3">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        Qty
                      </InputLabel>
                      <OutlinedInput
                        type="number"
                        name="Qty"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                      />
                    </FormControl>
                  </Box>
                </Box>
                <Box className="firstHeading4">
                  <Typography variant="h5">Weight</Typography>
                  <Box className="input4">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        500 kgs
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        name="weight"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                      />
                    </FormControl>
                  </Box>
                </Box>
                <Box className="firstHeading5">
                  <Typography variant="h5">Size</Typography>
                  <Box className="input13">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        500
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        name="sizeInput"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                      />
                    </FormControl>
                  </Box>
                  <Box className="input8">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <Select
                        native
                        onBlur={(e) => handleChangePdValue(e, i)}
                        name="sizeSelect"
                        required
                      >
                        <option aria-label="None" value="" selected disabled>
                          Please select
                        </option>
                        <option value={"INCH"}>INCH</option>
                        <option value={"CBM"}>CBM</option>
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
                <Box className="firstHeading6">
                  <Typography variant="h5">MSDS</Typography>
                  <Box className="input9">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password"></InputLabel>
                      <OutlinedInput
                        type="text"
                        name="MSDS2"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                      />
                    </FormControl>
                  </Box>
                </Box>
                <Box className="firstHeading7">
                  <Typography variant="h5">Packing</Typography>
                  <Box className="input10">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <Select
                        native
                        onBlur={(e) => handleChangePdValue(e, i)}
                        name="Packing"
                        required
                      >
                        <option aria-label="None" value="" selected disabled>
                          Please select
                        </option>
                        <option value={"Packed"}>Packed</option>
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
                <Box className="firstHeading8">
                  <Typography variant="h5">Package Type</Typography>
                  <Box className="input11">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        Pallets
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        required
                        name="packageType"
                        onBlur={(e) => handleChangePdValue(e, i)}
                      />
                    </FormControl>
                  </Box>
                </Box>
                <Box className="firstHeading9">
                  <Typography variant="h5">Gross Value</Typography>
                  <Box className="input12">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        AED 100,000
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        name="grossValue"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                      />
                    </FormControl>
                  </Box>
                  <Box className="DetailscheckBox">
                    <FormControlLabel
                      control={
                        <Checkbox
                          onBlur={(e) => handleChangePdValue(e, i)}
                          name="stackable"
                          value={true}
                          color="primary"
                        />
                      }
                      label="Stackable"
                    />
                  </Box>
                </Box>
              </Box>
            </>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default ProjectDetails;
